// import clone from 'clone'
// import { initialState } from '../index'
import { JOURNAL_INIT_LOADING, JOURNAL_INIT_SUCCESS, JOURNAL_INIT_FAIL, JOURNAL_COMMIT_KEY } from '@/store/types'

export const init = {
  [JOURNAL_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [JOURNAL_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [JOURNAL_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [JOURNAL_COMMIT_KEY](state, data) {
    state.journal.journalId.tranMode = data.tranMode
    state.journal.journalId.jrnlNo = data.jrnlNo
    state.journal.journalId.status = data.status
    state.journal.journalId.statusDesc = data.statusDesc
  }
}
